import React from 'react';
import { DynamicContentSection } from './DynamicContentSection';

export const AiInnovationSection: React.FC = () => {
  return (
    <DynamicContentSection 
      contentKey="AiInnovation"
      layout="image-left"
      showCta={false}
      showSingleImage={true}
      showBottomLine={false} // Explicitly disable bottom line
      image1Src="/images/notebook_used_by_ai.png"
      image1Alt="AI innovation and artificial intelligence technology"
    />
  );
};